import { DateTime } from "luxon";

export function formatDateTimeToDate(dateTime: DateTime): string {
	return dateTime.toFormat('yyyy-MM-dd')
}
